import { MDBIcon } from "mdb-react-ui-kit";

export const EmptyInbox = () => (
    <div className="text-center my-5">
        <MDBIcon fas icon="inbox" size="2xl" />
        <p className="mt-2">You've reached Inbox zero</p>
    </div >
)